import { LOGIN_ENDPOINT, LOGOUT_ENDPOINT, ME_ENDPOINT } from "./endpoints";
import { getAPI, postAPI } from "./apiMethods";

export async function getCurrentUser() {
  return getAPI(ME_ENDPOINT);
}

export async function login(email, password) {
  return postAPI(LOGIN_ENDPOINT, { email, password });
}

export async function logout() {
  // Optionally call backend logout endpoint if needed
  return postAPI(LOGOUT_ENDPOINT);
}

export async function resetPassword(oldPassword, newPassword) {
  return postAPI("/auth/reset-password", { oldPassword, newPassword });
}
